export default {
        T: `
1111111
   1   
   1   
   1   
   1   
   1   
   1   `,
        H: `
1     1
1     1
1     1
1111111
1     1
1     1
1     1`, 
        E: `
1111111
1      
1      
111111 
1      
1      
1111111`,
        I: `
1111111
   1   
   1   
   1   
   1   
   1   
1111111`,
        N: `
1     1
11    1
1 1   1
1  1  1
1   1 1
1    11
1     1`,
        B: `
111111 
1     1
1     1
111111 
1     1
1     1
111111 `, 
        W: `
1     1
1     1
1     1
1  1  1
1  1  1
1 1 1 1
 1   1 `
      }